module.exports = __webpack_public_path__ + "img/collectNot.8773170f.svg";